const { errors } = require('@transfeeradev/api-enums');

module.exports = class CpfCnpjBlacklist {
  static validate(cpfCnpj, blacklist) {
    if (cpfCnpj) {
      const isInBlacklist = _isInBlacklist(cpfCnpj, blacklist);
      if (isInBlacklist) {
        return {
          isValid: false,
          errorMessage: errors.ptBr.dba.DOCUMENT_BLACKLIST_BLOCKED.message,
          errorCode: errors.ptBr.dba.DOCUMENT_BLACKLIST_BLOCKED.code
        };
      }
    }
    return {
      isValid: true
    };
  }
};

const _isInBlacklist = (cpfCnpj, blacklist) =>
  Boolean(blacklist.find(blacklistItem => String(blacklistItem.number) === String(cpfCnpj)));
